/* SILVERCASE theme — working cart, variant picker, UI */
(function () {
  "use strict";
  var CFG = window.SILVERCASE || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money formatting (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var fmt = format || CFG.moneyFormat || "${{amount}}";
    function num(n, p, t, d) {
      p = isNaN(p = Math.abs(p)) ? 2 : p; t = t === undefined ? "," : t; d = d === undefined ? "." : d;
      var s = n < 0 ? "-" : "", i = parseInt(n = Math.abs(+n || 0).toFixed(p), 10) + "",
          j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
             (p ? d + Math.abs(n - i).toFixed(p).slice(2) : "");
    }
    var value = "", placeholder = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = placeholder ? placeholder[1] : "amount";
    switch (token) {
      case "amount": value = num(cents / 100.0, 2); break;
      case "amount_no_decimals": value = num(cents / 100.0, 0); break;
      case "amount_with_comma_separator": value = num(cents / 100.0, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = num(cents / 100.0, 0, ".", ","); break;
      default: value = num(cents / 100.0, 2);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }
  window.SCmoney = function (c) { return formatMoney(c); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#toast"); if (!t) return;
    $("#toastMsg").textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  function openCart() {
    var d = $("#drawer"), o = $("#overlay");
    if (!d) return;
    d.classList.add("open"); if (o) o.classList.add("open");
    d.setAttribute("aria-hidden", "false");
  }
  function closeCart() {
    var d = $("#drawer"), o = $("#overlay");
    if (!d) return;
    d.classList.remove("open"); if (o) o.classList.remove("open");
    d.setAttribute("aria-hidden", "true");
  }

  function renderCart(cart) {
    var count = cart.item_count;
    $$("#cartCount").forEach(function (el) { el.textContent = count; });
    var body = $("#cartBody"), sub = $("#subtotal");
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="empty"><div class="big">&#9645;</div>Your cart is empty.<br>Pick a print to get started.</div>';
      if (sub) sub.textContent = formatMoney(0);
      return;
    }
    body.innerHTML = "";
    cart.items.forEach(function (item) {
      var img = item.image ? item.image : (CFG.fallbackImages && CFG.fallbackImages[0]);
      var variant = (item.variant_title && item.variant_title.indexOf("Default") === -1) ? item.variant_title : (item.product_type || "");
      var row = document.createElement("div");
      row.className = "line";
      row.innerHTML =
        '<div class="line-img"><img src="' + img + '" alt=""></div>' +
        '<div class="line-info"><h4>' + item.product_title + '</h4>' +
        '<div class="sub">' + variant + '</div>' +
        '<div class="lc">' +
          '<button aria-label="Decrease" data-a="dec" data-key="' + item.key + '">&minus;</button>' +
          '<b>' + item.quantity + '</b>' +
          '<button aria-label="Increase" data-a="inc" data-key="' + item.key + '">+</button>' +
          '<button aria-label="Remove" data-a="rm" data-key="' + item.key + '" style="margin-left:6px">&#128465;</button>' +
        '</div></div>' +
        '<div class="line-price">' + formatMoney(item.final_line_price) + '</div>';
      body.appendChild(row);
    });
    body.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.dataset.key, a = b.dataset.a;
        var item = cart.items.filter(function (x) { return x.key === key; })[0];
        if (!item) return;
        var q = item.quantity;
        if (a === "inc") q = q + 1;
        if (a === "dec") q = Math.max(0, q - 1);
        if (a === "rm") q = 0;
        changeLine(key, q);
      });
    });
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(CFG.routes.cart_js, { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    fetch(CFG.routes.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  /* ---------- add to cart ---------- */
  function addToCart(form) {
    var btn = $("#addBtn", form);
    var data = new FormData(form);
    if (btn) { btn.disabled = true; btn.classList.add("loading"); }
    fetch(CFG.routes.cart_add, {
      method: "POST",
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: data
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.classList.remove("loading"); }
        if (!res.ok) { toast(res.body && res.body.description ? res.body.description : "Could not add to cart"); return; }
        toast((res.body.product_title || "Item") + " added");
        fetchCart().then(openCart);
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove("loading"); }
        form.submit(); // fall back to normal submit
      });
  }

  /* ---------- variant picker ---------- */
  function initBuyBlock() {
    var grid = $(".product-grid");
    if (!grid) return;
    var isDemo = grid.getAttribute("data-demo") === "true";
    var mainImg = $("#mainImg");
    var qtyEl = $("#qty");

    function selectVariant(el) {
      var img = el.getAttribute("data-image");
      var name = el.getAttribute("data-name");
      var price = el.getAttribute("data-price");
      var vid = el.getAttribute("data-variant");
      var available = el.getAttribute("data-available");

      if (mainImg && img) {
        mainImg.classList.add("swap");
        setTimeout(function () { mainImg.src = img; if (name) mainImg.alt = name; mainImg.classList.remove("swap"); }, 160);
      }
      $$(".thumb").forEach(function (t) { t.classList.toggle("active", t.getAttribute("data-variant") === vid && t.getAttribute("data-image") === img || (isDemo && t.getAttribute("data-image") === img)); });
      $$(".swatch").forEach(function (s) { s.classList.toggle("active", (vid && s.getAttribute("data-variant") === vid) || (isDemo && s.getAttribute("data-image") === img)); });
      var pn = $("#pickName"); if (pn && name) pn.textContent = name;
      var dn = $("#designName"); if (dn && name) dn.textContent = name;

      if (!isDemo && vid) {
        var vinput = $("#variantId"); if (vinput) vinput.value = vid;
        var cp = $("#curPrice"); if (cp && price) cp.textContent = formatMoney(price);
        var bp = $("#btnPrice"); if (bp && price) bp.textContent = formatMoney(price * (parseInt(qtyEl && qtyEl.value, 10) || 1));
        var addBtn = $("#addBtn"), addLabel = $("#addLabel");
        if (addBtn) {
          var avail = available === "true";
          addBtn.disabled = !avail;
          if (addLabel) addLabel.textContent = avail ? "Add to cart" : "Sold out";
          if (bp) bp.style.display = avail ? "" : "none";
        }
      }
    }

    $$(".thumb, .swatch").forEach(function (el) {
      el.addEventListener("click", function () { selectVariant(el); });
    });

    function syncBtnPrice() {
      var bp = $("#btnPrice"); if (!bp) return;
      var active = $(".swatch.active") || $(".thumb.active");
      var price = active && active.getAttribute("data-price");
      var q = parseInt(qtyEl && qtyEl.value, 10) || 1;
      if (price) bp.textContent = formatMoney(price * q);
      else if (isDemo) bp.textContent = "$" + (26 * q).toFixed(2);
    }

    var plus = $("#plus"), minus = $("#minus");
    if (plus) plus.addEventListener("click", function () { qtyEl.value = Math.min(99, (parseInt(qtyEl.value, 10) || 1) + 1); syncBtnPrice(); });
    if (minus) minus.addEventListener("click", function () { qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) - 1); syncBtnPrice(); });
    if (qtyEl) qtyEl.addEventListener("input", function () {
      var v = parseInt(qtyEl.value, 10) || 1; qtyEl.value = Math.max(1, Math.min(99, v)); syncBtnPrice();
    });

    var form = $("#buyForm");
    if (form) {
      form.addEventListener("submit", function (e) { e.preventDefault(); addToCart(form); });
    }
    var demoBtn = grid.querySelector('[data-demo="true"]#addBtn') || (isDemo ? $("#addBtn") : null);
    if (isDemo && demoBtn) {
      demoBtn.addEventListener("click", function () {
        toast("Add your product in Shopify admin to enable checkout");
      });
    }
  }

  /* ---------- cart page (+/- buttons) ---------- */
  function initCartPage() {
    var form = $("#cartForm"); if (!form) return;
    $$(".qbtn", form).forEach(function (b) {
      b.addEventListener("click", function () {
        var line = b.getAttribute("data-line");
        var input = form.querySelector('.qinput[data-line="' + line + '"]');
        if (!input) return;
        var v = parseInt(input.value, 10) || 0;
        input.value = b.getAttribute("data-a") === "inc" ? v + 1 : Math.max(0, v - 1);
        form.querySelector('[name="update"]').click();
      });
    });
  }

  /* ---------- header / drawer wiring ---------- */
  function initChrome() {
    var open = $("#cartOpen");
    if (open) open.addEventListener("click", function (e) { e.preventDefault(); fetchCart().then(openCart); });
    var close = $("#cartClose"); if (close) close.addEventListener("click", closeCart);
    var ov = $("#overlay"); if (ov) ov.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    var mt = $("#menuToggle"), mnav = $("#mobileNav");
    if (mt && mnav) {
      mt.addEventListener("click", function () {
        var openNow = mnav.classList.toggle("open");
        mt.setAttribute("aria-expanded", openNow);
      });
      $$("a", mnav).forEach(function (a) {
        a.addEventListener("click", function () { mnav.classList.remove("open"); mt.setAttribute("aria-expanded", "false"); });
      });
    }
  }

  /* ---------- ticker ---------- */
  function initTicker() {
    var track = $("#ticker"); if (!track) return;
    var items = ["Free shipping over $35", "Brushed stainless steel", "Holds 12 to 14 cards",
      "One press spring clip", "Sealed art print", "30 day returns", "Ten prints to pick from"];
    var html = items.map(function (t) { return "<span>" + t + "</span>"; }).join("");
    track.innerHTML = html + html;
  }

  /* ---------- init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    initChrome();
    initBuyBlock();
    initCartPage();
    initTicker();
    if ($("#cartBody")) { fetchCart(); }
  });
})();
